import { Loader } from "components/common/Icons/Loader/Loader";
import { Modal } from "components/common/Modal/Modal";
import { useIconsModal } from "./useIconsModal";
import { Icon } from "./Icon/Icon";
import { Search } from "./Search/Search";
import { CloseIcon } from "components/common/Icons/CloseIcon";
import { Translate } from "components/common/Translate/Translate";
import { stopPropagation } from "client/utils/stopPropagation";

interface IconsModalProps {
    isOpen: boolean;
    close: () => void;
}

export const IconsModal = ({ isOpen, close }: IconsModalProps) => {
    const { filteredIcons, isFetching, handleIconClick, handleSearch, search, handleSearchCrossButtonClick } =
        useIconsModal(close);

    return (
        <Modal isOpen={isOpen} close={close}>
            <div className="max-h-screen grid place-items-center w-full h-full py-8 px-8">
                <div
                    className="relative bg-white dark:bg-darkSurface-200 rounded-lg max-h-full scroll w-[min(100%,884px)] mx-auto"
                    onClick={stopPropagation()}
                >
                    {isFetching ? (
                        <div className="w-full h-full grid place-items-center py-8">
                            <Loader className="stroke-[lightgray]" width={25} height={25} />
                        </div>
                    ) : (
                        <>
                            <div className="flex flex-col justify-center text-black dark:text-white">
                                <div className="sticky top-0 z-10 bg-white dark:bg-darkSurface-200 pt-8 pb-2 px-4">
                                    <div className="text-lg font-semibold text-black dark:text-white mb-6">
                                        <Translate keyName="recommended-icons" />
                                    </div>
                                    <Search
                                        search={search}
                                        handleSearch={handleSearch}
                                        handleSearchCrossButtonClick={handleSearchCrossButtonClick}
                                    />
                                    <button
                                        className="absolute top-8 right-4 grid place-items-center w-6 h-6 bg-irGray-300 dark:bg-darkSurface-300 rounded-full z-20"
                                        onClick={close}
                                    >
                                        <CloseIcon />
                                    </button>
                                </div>
                                <div className="flex flex-wrap items-center justify-center gap-4 lg:gap-[14px] px-4 py-8">
                                    {filteredIcons.map((icon) => (
                                        <Icon key={icon.id} icon={icon} handleClick={handleIconClick} />
                                    ))}
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </Modal>
    );
};
